
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sports/[sport]",
      function () {
        return require("private-next-pages/sports/[sport].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sports/[sport]"])
      });
    }
  